'use client';

import { Suspense } from 'react';

import { CategoryProvider } from '@/modules/product/context/CategoryContext';
import { SearchPageConfigFragment } from '@/modules/product/gql/__generated/searchPage.generated';
import SearchPageTemplateSimplified from '@/modules/product/pages/SearchPageTemplateSimplified';

type SearchPageProps = {
  searchPageConfig: SearchPageConfigFragment | null;
};

export function SearchPage({ searchPageConfig }: SearchPageProps) {
  return (
    <CategoryProvider>
      <Suspense>
        <SearchPageTemplateSimplified searchPageConfig={searchPageConfig} />
      </Suspense>
    </CategoryProvider>
  );
}
